<template>
    <div class="personnel_container">
        <!-- 搜索区域 -->
        <global-tag>
            <span slot="title">人员信息</span>
            <div class="search" slot="search">
                <el-form label-width="100px">
                    <el-row>
                        <el-col :span="4">
                            <el-form-item label="人员姓名：">
                                <el-input
                                    v-model="personName"
                                    placeholder="请输入名称"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="手机号码：">
                                <el-input
                                    v-model="personPhone"
                                    placeholder="请输入手机号码"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" style="margin-left: 10px">
                            <el-form-item label="身份证号码：">
                                <el-input
                                    v-model="personIdentity"
                                    placeholder="请输入身份证号码"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="2" :offset="1">
                            <el-button
                                type="primary"
                                class="searchBtns"
                                @click="queryList"
                                >搜索</el-button
                            >
                        </el-col>
                        <el-col :span="4">
                            <el-button
                                type="info"
                                class="resetReach"
                                @click="handleResert"
                                >清除条件</el-button
                            >
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </global-tag>
        <div class="table_title">
            <div class="btn_group">
                <el-button-group>
                    <el-button
                        type="success"
                        icon="el-icon-plus"
                        class="openBtns"
                        @click="handleTableForm('新增')"
                        >新增</el-button
                    >
                    <el-button type="primary" @click="management"
                        >部门管理</el-button
                    >
                </el-button-group>
            </div>
            <div class="screen_container">
                <el-button-group>
                    <el-button
                        type="primary"
                        icon="el-icon-refresh"
                        class="dropRests"
                        @click="Reset1"
                    ></el-button>
                    <!-- <el-button type="primary" style="padding: 10px 20px"> -->
                    <el-dropdown
                        class="dropdown1"
                        trigger="click"
                        :hide-on-click="false"
                    >
                        <span class="el-dropdown-link">
                            <i
                                class="el-icon-s-grid el-icon--right"
                                style="color: #fff"
                            ></i>
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu
                            slot="dropdown"
                            class="table_checkbox"
                        >
                            <el-dropdown-item>
                                <el-checkbox-group
                                    v-model="tableChekbox"
                                    @change="tableChekboxChange"
                                >
                                    <el-checkbox label="序号"></el-checkbox>
                                    <br />
                                    <el-checkbox label="部门名称"></el-checkbox>
                                    <br />
                                    <el-checkbox label="名称"></el-checkbox>
                                    <br />
                                    <el-checkbox label="性别"></el-checkbox>
                                    <br />
                                    <el-checkbox label="手机号"></el-checkbox>
                                    <br />
                                    <el-checkbox label="身份证号"></el-checkbox>
                                    <br />
                                    <el-checkbox label="创建人"></el-checkbox>
                                    <br />
                                    <el-checkbox label="状态"></el-checkbox>
                                    <br />
                                    <el-checkbox label="操作"></el-checkbox>
                                </el-checkbox-group>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <!-- </el-button> -->
                </el-button-group>
            </div>
        </div>
        <!-- 页面表格 -->
        <div class="table_container">
            <el-table
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                height="550"
                :header-cell-style="{ background: '#e6e6e6', color: '#000' }"
                border
            >
                <el-table-column
                    type="index"
                    width="60px"
                    label="序号"
                    align="center"
                    show-overflow-tooltip
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '序号'
                        ) != -1
                    "
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    min-width="120px"
                    label="部门名称"
                    prop="deptName"
                    :show-overflow-tooltip="true"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '部门名称'
                        ) != -1
                    "
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    min-width="120px"
                    label="姓名"
                    prop="personName"
                    :show-overflow-tooltip="true"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '名称'
                        ) != -1
                    "
                ></el-table-column>
                <el-table-column
                    align="center"
                    min-width="80px"
                    label="性别"
                    prop="personSex"
                    :show-overflow-tooltip="true"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '性别'
                        ) != -1
                    "
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.personSex == 1">男</span>
                        <span v-if="scope.row.personSex == 2">女</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    min-width="120px"
                    label="手机号"
                    prop="personPhone"
                    :show-overflow-tooltip="true"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '手机号'
                        ) != -1
                    "
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    min-width="150px"
                    label="身份证号"
                    prop="personIdentity"
                    :show-overflow-tooltip="true"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '身份证号'
                        ) != -1
                    "
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="createPersonName"
                    min-width="60px"
                    label="创建人"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '创建人'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    align="center"
                    min-width="90px"
                    label="状态"
                    prop="status"
                    :show-overflow-tooltip="true"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '状态'
                        ) != -1
                    "
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 0">启用</span>
                        <span v-if="scope.row.status == 1">禁用</span>
                    </template>
                </el-table-column>
                <el-table-column
                    width="150px"
                    align="center"
                    label="操作"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '操作'
                        ) != -1
                    "
                >
                    <template slot-scope="scope">
                        <el-tooltip
                            class="item"
                            effect="dark"
                            content="查看"
                            placement="top-start"
                        >
                            <img
                                src="../assets/img/detail.png"
                                style="cursor: pointer"
                                @click="handleTableForm('详情', scope.row)"
                            />
                        </el-tooltip>
                        <el-tooltip
                            effect="dark"
                            content="编辑"
                            placement="top-start"
                        >
                            <img
                                src="../assets/img/table_edit.png"
                                @click="handleTableForm('编辑', scope.row)"
                                style="margin-left: 12px; cursor: pointer"
                            />
                        </el-tooltip>
                        <el-tooltip
                            class="item"
                            effect="dark"
                            content="删除"
                            placement="top-start"
                        >
                            <img
                                src="../assets/img/table_delete.png"
                                alt
                                @click="deleteItem(scope.row)"
                                style="margin-left: 12px; cursor: pointer"
                            />
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination_container">
            <el-pagination
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageConfig.total"
                :page-size="pageConfig.pageSize"
                :current-page.sync="pageConfig.pageNo"
                @size-change="handletableSize"
                @current-change="handleTableChange"
            ></el-pagination>
        </div>
        <!-- 表格表单弹窗 -->
        <el-dialog
            :title="dialogVisibleTitle"
            :visible.sync="dialogVisible"
            width="40%"
            :close-on-click-modal="false"
            class="dialog_container"
            @close="dialogVisibleClone"
        >
            <div class="dialog_content">
                <el-form
                    label-position="left"
                    label-width="100px"
                    ref="formData"
                    :model="formData"
                    :rules="formDataRules"
                    :disabled="dialogVisibleTitle == '详情'"
                >
                    <el-form-item label="部门名称：" prop="deptId">
                        <el-select
                            v-model="formData.deptId"
                            placeholder="请选择部门"
                            style="width: 100%"
                            @change="handleSelectDept"
                            @click.native="clearNameList"
                        >
                            <el-option
                                v-for="item in selectDepartmentList"
                                :key="item.id"
                                :label="item.deptName"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="人员姓名：" prop="personName">
                        <!-- <el-input v-model="formData.name"></el-input> -->
                        <el-select
                            v-model="formData.personName"
                            filterable
                            remote
                            :disabled="
                                dialogVisibleTitle === '详情' ||
                                dialogVisibleTitle === '编辑' ||
                                !this.formData.deptId
                            "
                            ref="fuzzySearch"
                            style="width: 100%"
                            placeholder="请输入关键词"
                            :remote-method="remoteMethod"
                            @change="handleSelect"
                            @click.native="clearForm"
                            :loading="loading"
                            solt="empty"
                        >
                            <el-option
                                v-for="item in options"
                                :key="item.id"
                                :label="item.personName"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="身份证号：" prop="personIdentity">
                        <!-- <el-input
                            v-model="formData.personIdentity"
                            @blur="getSex"
                        ></el-input> -->
                        <el-select
                            v-model="formData.personIdentity"
                            filterable
                            remote
                            :disabled="
                                dialogVisibleTitle === '详情' ||
                                dialogVisibleTitle === '编辑' ||
                                !this.formData.deptId
                            "
                            ref="fuzzySearch"
                            style="width: 100%"
                            placeholder="请输入关键词"
                            :remote-method="remoteMethod1"
                            @change="handleSelect"
                            @click.native="clearForm1"
                            :loading="loading"
                            solt="empty"
                        >
                            <el-option
                                v-for="item in options"
                                :key="item.id"
                                :label="item.personIdentity"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="性别：">
                        <el-radio-group v-model="formData.personSex" disabled>
                            <el-radio label="1">男</el-radio>
                            <el-radio label="2">女</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="手机号：" prop="personPhone">
                        <el-input
                            v-model="formData.personPhone"
                            disabled
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="状态：">
                        <el-radio-group v-model="formData.status">
                            <el-radio label="0">启用</el-radio>
                            <el-radio label="1">禁用</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    :disabled="isdisabled"
                    @click="savedata"
                    >确 定</el-button
                >
                <el-button @click="dialogVisible = false">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 部门管理弹窗 -->
        <el-dialog
            :title="departmentDialogTitle"
            :visible.sync="departmentDialog"
            width="40%"
            :close-on-click-modal="false"
            class="dialog_container personnel_dialog"
            @close="departmentDialogTitleClose"
        >
            <div class="table_add_wraoper">
                <el-button
                    type="success"
                    icon="iconfont icon-xinzeng"
                    @click="handleTableAddForm('新增')"
                    >新增</el-button
                >
                <div class="add_table">
                    <el-table
                        :data="departmentList"
                        tooltip-effect="dark"
                        style="width: 100%"
                        height="200"
                        :header-cell-style="{
                            background: '#e6e6e6',
                            color: '#000',
                        }"
                        border
                    >
                        <el-table-column
                            type="index"
                            width="70px"
                            prop="id"
                            label="序号"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            align="center"
                            prop="deptName"
                            label="部门名称"
                            :show-overflow-tooltip="true"
                        ></el-table-column>
                        <el-table-column
                            align="center"
                            prop="createPersonName"
                            label="创建人"
                            :show-overflow-tooltip="true"
                        ></el-table-column>
                        <el-table-column
                            align="center"
                            prop="status"
                            label="状态"
                            :show-overflow-tooltip="true"
                        >
                            <template slot-scope="scope">
                                <span v-if="scope.row.status == 0">启用</span>
                                <span v-if="scope.row.status == 1">禁用</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="操作">
                            <template slot-scope="scope">
                                <el-tooltip
                                    effect="dark"
                                    content="编辑"
                                    placement="top-start"
                                >
                                    <img
                                        src="../assets/img/table_edit.png"
                                        @click="
                                            handleTableAddForm(
                                                '编辑',
                                                scope.row
                                            )
                                        "
                                        style="
                                            margin-left: 12px;
                                            cursor: pointer;
                                        "
                                    />
                                </el-tooltip>
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    content="删除"
                                    placement="top-start"
                                >
                                    <img
                                        src="../assets/img/table_delete.png"
                                        alt
                                        style="
                                            margin-left: 12px;
                                            cursor: pointer;
                                        "
                                        @click="deleteItem2(scope.row)"
                                    />
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pagination_container">
                    <el-pagination
                        layout="total, sizes, prev, pager, next, jumper"
                        :page-size="pageSize"
                        :total="total"
                        :current-page.sync="pageNo"
                        @size-change="handletableDataSize"
                        @current-change="handleTableDataChange"
                    ></el-pagination>
                </div>
            </div>
            <span
                slot="footer"
                class="dialog-footer"
                style="display: none"
            ></span>
        </el-dialog>
        <el-dialog
            :title="addDialogTitle"
            :visible.sync="addDialog"
            width="40%"
            :close-on-click-modal="false"
            class="dialog_container"
            @close="addDialogClose"
        >
            <div class="dialog_content">
                <el-form
                    label-position="left"
                    label-width="100px"
                    :model="addFormData"
                >
                    <el-form-item label="部门名称：">
                        <el-input v-model="addFormData.deptName"></el-input>
                    </el-form-item>
                    <el-form-item label="所属机构:" prop="dataId">
                        <el-input
                            v-if="addFormData.dataName"
                            v-model="addFormData.dataName"
                            disabled
                        ></el-input>
                        <el-cascader
                            :options="orgList"
                            v-model="addFormData.dataId"
                            style="width: 100%"
                            ref="tree"
                            :props="{
                                checkStrictly: true,
                                emitPath: false,
                                label: 'label',
                                value: 'orgId',
                            }"
                            v-else
                        ></el-cascader>
                    </el-form-item>
                    <el-form-item label="状态:">
                        <el-radio-group v-model="addFormData.status">
                            <el-radio label="0">启用</el-radio>
                            <el-radio label="1">禁用</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="save">确 定</el-button>
                <el-button @click="addDialog = false">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import request from "@/utils/request.js"
import common from "../../../utils/common.js"
import globalTag from "../components/globalTag"
import { post, get } from "@/api/requrestHttp.js"
import { discriCard, chekCode, chekPhone } from "../util"

export default {
    name: "proManage",
    data() {
        var checkIdCode = (rule, value, callback) => {
            if (!chekCode(value)) {
                return callback(new Error("身份证号格式错误"))
            }
            const info = discriCard(value)
            //this.formData.sex = info.sex
            callback()
        }
        var chekPhone = (rule, value, callback) => {
            let validatePhone = /^1[0-9]{10}$/
            if (!validatePhone.test(value)) {
                return callback(new Error("手机号格式错误"))
            }
            callback()
        }
        return {
            defaultProps: {
                children: "children",
                label: "label",
            },
            orgLevels: "",
            isdisabled: false,
            orgList: [],
            arrOrgList: [],
            personName: "", //人员名称
            personPhone: "", //手机号
            personIdentity: "", //身份证
            currentPage: 1, //默认展示第一页
            total: 0,
            pageNo: 1,
            pageSize: 10,
            tableData: [],
            formData: {
                id: "",
                //table表单
                personName: "",
                personSex: "",
                deptId: "",
                personPhone: "",
                personIdentity: "",
                status: "0",
                orgId: "",
                orgName: "",
            },
            loading: false,
            options: [],
            formDataRules: {
                personName: [
                    {
                        required: true,
                        message: "人员名称不能为空",
                        trigger: "blur",
                    },
                ],
                // orgName:[{required: true, message: '人员名称不能为空', trigger: 'change' }],
                deptId: [
                    {
                        required: true,
                        message: "部门名称不能为空",
                        trigger: "blur",
                    },
                ],
                personPhone: [
                    {
                        required: true,
                        message: "手机号不能为空",
                        trigger: "blur",
                    },
                    { validator: chekPhone, trigger: "blur" },
                ],
                personIdentity: [
                    {
                        required: true,
                        message: "身份证不能为空",
                        trigger: "blur",
                    },
                    { validator: checkIdCode, trigger: "blur" },
                ],
            },
            pageConfig: {
                pageSize: 10,
                total: 0,
                pageNo: 1,
            },
            dialogVisible: false, //table表单弹窗
            dialogVisibleTitle: "", //table表单弹窗title
            tempTableChekbox: [
                "序号",
                "部门名称",
                "名称",
                "性别",
                "手机号",
                "身份证号",
                "创建人",
                "状态",
                "操作",
            ],
            tableChekbox: [
                "序号",
                "部门名称",
                "名称",
                "性别",
                "手机号",
                "身份证号",
                "创建人",
                "状态",
                "操作",
            ],
            addDialog: false, //部门弹窗里面新增表单
            addDialogTitle: "新增", //部门弹窗里面新增表单title
            addFormData: {
                //部门弹窗里面新增表form
                deptName: "",
                status: "0",
            },
            departmentList: [],
            departmentDialogTitle: "查看", //部门弹窗title
            departmentDialog: false, //部门弹窗
            selectDepartmentList: [],
            depNo: "",
            dataId: "",
        }
    },
    components: {
        globalTag,
    },
    inject: ["reload"], //注入
    methods: {
        getSex() {
            let sex = this.formData.idCode.substring(16, 17)
            if (sex % 2 === 0) this.formData.sex = "2"
            else this.formData.sex = "1" //1男2女
        },
        getchangeList(query, query1) {
            this.selectDepartmentList.forEach((item) => {
                if (item.id == this.formData.deptId) {
                    this.$http
                        .request({
                            url: "/ypt/admin/serviceStaff/info/findList",
                            method: "POST",
                            data: {
                                pageNo: 1,
                                pageSize: -1,
                                personName: query,
                                personIdentity: query1,
                                dataId: item.dataId,
                            },
                        })
                        .then((res) => {
                            if (res.code == 200) {
                                if (res.content != null) {
                                    this.options = res.content.list
                                } else {
                                    this.options = []
                                }
                                this.loading = false
                            }
                        })
                }
            })
        },

        remoteMethod(query) {
            if (query !== "") {
                this.loading = true
                this.getchangeList(query, "")
            } else {
                this.options = []
            }
        },
        remoteMethod1(query) {
            if (query !== "") {
                this.loading = true
                this.getchangeList("", query)
            } else {
                this.options = []
            }
        },
        clearNameList(val) {
            // console.log(val)
            this.options = []
            this.formData = {}
        },
        handleSelectDept(val) {
            this.selectDepartmentList.forEach((item) => {
                if (item.id == val) {
                    this.dataId = item.dataId
                    // console.log(this.dataId)
                }
            })
        },
        handleSelect(val) {
            // console.log(val, this.options)
            let item = {}
            this.options.forEach((item) => {
                if (item.id == val) {
                    this.formData.personName = JSON.parse(
                        JSON.stringify(item)
                    ).personName
                    this.formData.personPhone = JSON.parse(
                        JSON.stringify(item)
                    ).personPhone
                    this.formData.personIdentity = JSON.parse(
                        JSON.stringify(item)
                    ).personIdentity
                    this.formData.personSex = JSON.parse(
                        JSON.stringify(item)
                    ).personSex
                    this.formData.dataId = this.dataId
                }
            })
            this.$forceUpdate()
        },

        clearForm(val) {
            // console.log(val)
            if (val) {
                if (this.dialogVisibleTitle == "新增") {
                    this.formData.personName = ""
                    this.formData.personSex = ""
                    this.formData.personIdentity = ""
                    this.formData.personPhone = ""
                }
                if (!this.formData.deptId) {
                    this.$message({
                        message: "请先选择部门",
                        type: "warning",
                    })
                    return false
                }
            }
        },
        clearForm1(val) {
            if (val) {
                if (this.dialogVisibleTitle == "新增") {
                    this.formData.personName = ""
                    this.formData.personSex = ""
                    this.formData.personIdentity = ""
                    this.formData.personPhone = ""
                }
                if (!this.formData.deptId) {
                    this.$message({
                        message: "请先选择部门",
                        type: "warning",
                    })
                    return false
                }
            }
        },
        sexChange(val) {
            // console.log(val)
        },
        management() {
            this.departmentDialog = true
            this.departmentlist()
        },
        //获取组织机构
        getOrg() {
            this.$http
                .request({
                    url: "/rbac/admin/org/info/OrgTreelist",
                    method: "POST",
                    data: {
                        isValid: 1,
                    },
                })
                .then((res) => {
                    // console.log(res)
                    if (res.code == 200 && res.content) {
                        let item = this.chbehavior(
                            res.content,
                            this.$store.state.info.orgId
                        )
                        this.orgList.push(item)
                        // console.log(this.orgList)
                    }
                })
        },
        chbehavior(arr, id) {
            let res
            ;(function deepId(arr, id) {
                for (let a of arr) {
                    if (a.orgId == id) {
                        res = a
                    } else if (a.children && !res) {
                        deepId(a.children, id)
                    }
                }
            })(arr, id)
            return res
        },
        //获取组织机构的名称
        setDataName(arr, id) {
            let res
            ;(function deepId(arr, id) {
                for (let a of arr) {
                    if (a.orgId == id) {
                        res = a.label
                    } else if (a.children && !res) {
                        deepId(a.children, id)
                    }
                }
            })(arr, id)
            return res
        },

        // 保留条件刷新
        Reset1() {
            this.showlist(true)
            this.tableChekbox = [
                "序号",
                "部门名称",
                "名称",
                "性别",
                "手机号",
                "身份证号",
                "状态",
                "操作",
            ]
        },

        // 页面刷新
        Reset() {
            this.reload()
        },
        //table列checkbox发生变化
        tableChekboxChange(val) {
            this.tempTableChekbox = val.map((item) => item)
        },
        //人员信息
        async showlist(e) {
            let params = {
                pageNo: this.pageConfig.pageNo,
                pageSize: this.pageConfig.pageSize,
                personName: e === true ? "" : this.personName,
                phone: e === true ? "" : this.phone,
                idCode: e === true ? "" : this.idCode,
                orgId: JSON.parse(localStorage.getItem("czUserInfo")).orgId,
            }
            params = Object.assign({}, params, {
                ...e,
            })
            await request({
                url: "/jjyl/admin/personMsg/info/findList",
                method: "POST",
                data: params,
            }).then((res) => {
                this.pageConfig.total = res.content.count
                this.tableData = res.content.list
                this.total = res.content.count
            })
        },
        // 保存
        async savedata() {
            if (this.dialogVisibleTitle === "详情") {
                this.dialogVisible = false
                return
            }
            let obj = common.organization(this.arrOrgList, this.orgLevels)
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    let params = {
                        ...this.formData,
                        qujiId: obj.qujiId,
                        shengjiId: obj.shengjiId,
                        shijiId: obj.shijiId,
                        stationId: obj.stationId,
                        shequjiId: obj.shequjiId,
                    }
                    params = Object.assign({}, params)
                    request({
                        url: "/jjyl/admin/personMsg/info/insertOrUpdate",
                        method: "POST",
                        data: params,
                    }).then((res) => {
                        // console.log(res)
                        if (res.code === 200) {
                            this.isdisabled = true
                            this.$message.success("保存成功")
                            this.showlist()
                            this.$post(
                                "/jjyl/admin/person/info/insertServePerson",
                                {
                                    mobilePhone: this.formData.phone,
                                    sche: 1,
                                }
                            ).then((result) => {
                                // console.log(result)
                                this.showlist()
                            })
                        } else {
                            this.$message.error("保存失败")
                        }
                        this.dialogVisible = false
                    })
                } else {
                    return false
                }
            })
        },
        // 查看
        async query(data) {
            let params = {
                id: data.id,
            }
            params = Object.assign({}, params)
            await request({
                url: "/jjyl/admin/personMsg/info/getById",
                method: "POST",
                data: params,
            }).then((res) => {
                // console.log(res)
                this.formData = res.content
            })
        },
        // 删除
        deleteItem(data) {
            this.$confirm("确认永久删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                request({
                    url: "/jjyl/admin/personMsg/info/deleteById",
                    method: "POST",
                    data: { id: data.id },
                }).then((res) => {
                    this.showlist()
                    this.$post("/jjyl/admin/person/info/insertServePerson", {
                        mobilePhone: data.phone,
                        delappPer: "1",
                        sche: 1,
                    }).then((res) => {
                        // console.log(res)
                        if (res.code === 200) {
                            this.$message.success("删除成功!")
                        }
                        this.queryList()
                    })
                })
            })
        },
        //部门列表
        departmentlist() {
            let params = {
                pageNo: this.pageNo,
                pageSize: -1,
                qujiId: JSON.parse(localStorage.getItem("czUserInfo")).qujiId,
                shengjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shengjiId,
                shijiId: JSON.parse(localStorage.getItem("czUserInfo")).shijiId,
                stationId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .stationId,
                shequjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shequjiId,
            }
            params = Object.assign({}, params)
            request({
                url: "/jjyl/admin/deptManage/info/findList",
                method: "POST",
                data: params,
            }).then((res) => {
                // console.log(res)
                if (res.content == null && res.content == "null") {
                    return
                }
                res.content.list.forEach((item) => {
                    item.id = String(item.id)
                })
                this.departmentList = res.content.list
                this.selectDepartmentList = res.content.list.filter(
                    (item) => item.status == 0
                )
                this.total = res.content.count
            })
        },
        //老人信息列表pagesize发生改变
        handletableDataSize(val) {
            this.pageSize = val
            this.departmentlist()
        },
        //老人信息列表页码发生改变
        handleTableDataChange(val) {
            this.pageNo = val
            this.departmentlist()
        },
        //老人信息列表pagesize发生改变
        handletableSize(val) {
            this.pageConfig.pageSize = val
            this.showlist()
        },
        //老人信息列表页码发生改变
        handleTableChange(val) {
            this.pageConfig.pageNo = val
            this.showlist()
        },
        // 新增
        async save() {
            if (this.addFormData.deptName === "") {
                this.$message.error("部门名称不能为空")
                return
            }
            let params = {
                ...this.addFormData,
                qujiId: JSON.parse(localStorage.getItem("czUserInfo")).qujiId,
                shengjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shengjiId,
                shijiId: JSON.parse(localStorage.getItem("czUserInfo")).shijiId,
                stationId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .stationId,
                shequjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shequjiId,
            }
            params = Object.assign({}, params)
            await request({
                url: "/jjyl/admin/deptManage/info/insertOrUpdate",
                method: "POST",
                data: params,
            }).then((res) => {})
            this.addDialog = false
            this.departmentlist()
        },
        // 删除
        deleteItem2(data) {
            this.$confirm("确认永久删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                request({
                    url: "/jjyl/admin/deptManage/info/deleteById",
                    method: "POST",
                    data: { id: data.id },
                }).then((res) => {
                    if (res.code == 200) {
                        if (res.message == "删除部门管理成功") {
                            this.$message({
                                type: "success",
                                message: res.message,
                            })
                        } else {
                            this.$message({
                                type: "warning",
                                message: res.message,
                            })
                        }
                    }
                    // console.log(res)
                    this.showlist()

                    this.departmentlist()
                })
            })
        },
        // 查看
        async look(data) {
            let params = {
                id: data.id,
            }
            params = Object.assign({}, params)
            await request({
                url: "/jjyl/admin/deptManage/info/getById",
                method: "POST",
                data: params,
            }).then((res) => {
                // console.log(res)
                this.addFormData = res.content
                this.addFormData.dataName = this.setDataName(
                    this.orgList,
                    res.content.dataId
                )
            })
        },
        // 查询
        queryList() {
            post("/jjyl/admin/personMsg/info/findList", {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                personName: this.personName,
                personSex: this.personSex,
                personPhone: this.personPhone,
                personIdentity: this.personIdentity,
                orgId: JSON.parse(localStorage.getItem("czUserInfo")).orgId,
            }).then((res) => {
                if (res.content == null) {
                    this.tableData = []
                } else {
                    this.tableData = res.content.list
                    this.total = res.content.count
                }
            })
        },
        resert() {
            this.formData = {
                name: "",
                sex: "",
                deptId: "",
                phone: "",
                idCode: "",
                status: "",
            }
        },
        handleTableForm(title, data) {
            //处理table表格表单
            this.dialogVisibleTitle = title
            this.dialogVisible = true
            this.isdisabled = false
            switch (title) {
                case "新增":
                    this.formData = {
                        id: "",
                        personName: "",
                        personSex: "",
                        deptId: "",
                        personPhone: "",
                        personIdentity: "",
                        status: "0",
                        orgId: "",
                        orgName: "",
                    }
                    break
                case "详情":
                    this.query(data)
                    break
                case "编辑":
                    this.query(data)
                    break
            }
        },
        handleTableAddForm(title, data) {
            //表单内新增
            this.addDialogTitle = title
            this.addDialog = true
            // console.log(title, "title")
            switch (title) {
                case "新增":
                    // console.log(title, "新增")
                    this.addFormData.dataId = ""
                    this.addFormData.dataName = ""
                    this.addFormData.id = ""
                    break
                case "编辑":
                    // console.log(title, "编辑")
                    this.look(data)
                    break
            }
        },
        //table表格表单弹窗关闭时事件
        dialogVisibleClone() {
            this.formData.name = ""
            this.formData.sex = ""
            this.formData.deptId = ""
            this.formData.phone = ""
            this.formData.idCode = ""
            this.formData.status = ""
            this.formData.orgName = ""
            delete this.formData.id
            this.$refs.formData.resetFields()
        },
        addDialogClose() {
            //table表格表单新增弹窗关闭时事件
            this.addFormData.deptName = ""
            this.addFormData.status = "0"
        },
        departmentDialogTitleClose() {
            // 部门弹窗关闭时事件
            this.pageSize = 10
            this.pageNo = 1
            this.departmentlist()
        },
        handleResert() {
            this.personName = "" //人员名称
            this.personPhone = "" //手机号
            this.personIdentity = "" //身份证
            this.pageSize = 10
            this.pageNo = 1
            this.queryList()
        },
    },
    created() {
        this.getOrg()
        this.showlist()
        this.departmentlist()
    },
}
</script>

<style lang="less" scoped>
.table_container {
    width: 100%;
}

/deep/ .personnel_dialog {
    .add_table {
        margin-top: 24px;
    }

    .el-dialog__footer {
        display: none;
    }
}
</style>